// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"b5bb377d","147":"1026e824","150":"d3933a66","288":"d7724b86","458":"bb4f0996","472":"d5cfac22","486":"2a00984f","583":"48e36363","653":"9f0c5ee4","726":"d9292b3d","791":"fb67ee18","892":"6064e637"}[chunkId] + ".chunk.js";
};